var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fades" } }, [
    _c(
      "div",
      {
        staticClass: "leon-loading",
        staticStyle: { "z-index": "9999" },
        on: {
          mousewheel: function($event) {
            $event.preventDefault()
          },
          scroll: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "lottie" },
          [
            _c("lottie", {
              attrs: { options: _vm.defaultOptions, height: 80, width: 80 },
              on: { animCreated: _vm.handleAnimation }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-4d6a9b3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4d6a9b3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/LeonLoading/src/main.vue
// module id = null
// module chunks = 